<ng-template #modal let-modal class="modal-dialog-centered">
    <div class="modal-header">
        <h4 class="modal-title text-center w-100" id="modalLabel">{{ modalTitle | translate }}</h4>
        <button type="button" class="btn-close" tabindex="-1" aria-label="Close" (click)="closeModal()">
        </button>
    </div>
    <div class="modal-body p-1">
        <div *ngIf="loading" class="row" style="height: 30px">
            <app-ui-preloader id="spinner" [display]="loading" [size]="'20px'"></app-ui-preloader>
        </div>

        <!-- <div *ngIf="!loading" id="tab" class="col-md-12">
            <ul ngbNav #tab="ngbNav" [(activeId)]="tabsPriority" class="nav-tabs nav-bordered">
                <ng-container *ngFor="let language of languages; let i = index">
                    <li [ngbNavItem]="i+1">
                        <a ngbNavLink>
                            {{language.description}}
                        </a>

                        <ng-template ngbNavContent>
                            <ng-container *ngTemplateOutlet="language.locale=='pt'?Tab1:Tab2">
                            </ng-container>
                        </ng-template>
                    </li>
                </ng-container>

            </ul>

            <div [ngbNavOutlet]="tab"></div>
        </div> -->
        <ng-container *ngTemplateOutlet="Tab1">
        </ng-container>
    </div>

    <div class="mt-1 mb-2 d-flex justify-content-center">
        <button *ngIf="priorityForm.value.Id !=0 && priorityForm.value.Id !=null"  class="btn btn-primary waves-effect waves-light btnSaveBottom mt-1 btnSaveMinW2" [disabled]="loading" (click)="save()"  >
          {{'SETTINGS.PRIORITY.EDITPRIORITY'|translate}}
        </button>
        <button *ngIf="priorityForm.value.Id ==0 || priorityForm.value.Id ==null" class="btn btn-primary waves-effect waves-light btnSaveBottom mt-1 btnSaveMinW2" [disabled]="loading" (click)="save()"  >
          {{'SETTINGS.PRIORITY.ADDPRIORITY'|translate}}
        </button>
      </div>
</ng-template>


<ng-template #Tab1>
    <form [formGroup]="priorityForm" class="p-2 mt-n2 form">
        <div class="row">
            <div class="col-md-12">
                <div class="mb-2">

                    <label for="field-3" class="form-label">{{ 'SETTINGS.PRIORITY.PRIORITY' | translate
                        }}</label>
                    <input type="text" class="form-control" id="field-3" formControlName="Priority"
                        [ngClass]="{'is-invalid':submitted && formPriority.Priority.invalid}" required>

                    <div *ngIf="submitted && formPriority.Priority.invalid" class="invalid-feedback">
                        <div *ngIf="formPriority.Priority.errors?.required" i18n>
                            {{ 'SETTINGS.PRIORITY.PRIORITYREQUIRED' | translate }}
                        </div>
                    </div>
                </div>
                <div class="mb-2">

                    <label class="form-label">{{ 'SETTINGS.PRIORITY.CUSTOMERPRIORIRY' | translate }}</label>
                    <input type="text" class="form-control" formControlName="CustomerPriority"
                        [ngClass]="{'is-invalid':submitted && formPriority.CustomerPriority.invalid}" required>

                    <div *ngIf="submitted && formPriority.CustomerPriority.invalid" class="invalid-feedback">
                        <div *ngIf="formPriority.CustomerPriority.errors?.required" i18n>
                            {{ 'SETTINGS.PRIORITY.CUSTOMERPRIORIRYREQUIRED' | translate }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</ng-template>

<!-- <ng-template #Tab2>
    <form [formGroup]="priorityForm" class="p-2 mt-n2 form">
        <div class="row">
            <div class="col-md-12">
                <div class="mb-2">
                    <label class="form-label">{{ 'SETTINGS.PRIORITY.PRIORITY' | translate }}</label>
                    <input type="text" class="form-control" formControlName="PriorityEN"
                        [ngClass]="{'is-invalid':submitted && formPriority.PriorityEN.invalid}" required>

                    <div *ngIf="submitted && formPriority.PriorityEN.invalid" class="invalid-feedback">

                        <div *ngIf="formPriority.PriorityEN.errors?.required" i18n>
                            {{ 'SETTINGS.PRIORITY.PRIORITYREQUIRED' | translate }}
                        </div>
                    </div>
                </div>
                <div class="mb-2">
                    <label class="form-label">{{ 'SETTINGS.PRIORITY.CUSTOMERPRIORIRY' | translate }}</label>
                    <input type="text" class="form-control" formControlName="CustomerPriorityEN"
                        [ngClass]="{'is-invalid':submitted && formPriority.CustomerPriorityEN.invalid}" required>

                    <div *ngIf="submitted && formPriority.CustomerPriorityEN.invalid" class="invalid-feedback">

                        <div *ngIf="formPriority.CustomerPriorityEN.errors?.required" i18n>
                            {{ 'SETTINGS.PRIORITY.CUSTOMERPRIORIRYREQUIRED' | translate }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</ng-template> -->